export const CHART_TYPE_BAR = 'bar'
export const CHART_TYPE_COLUMN = 'column'
export const BOX_WHISKER_PLOT = 'boxWhisker'
